var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.124H16.125V16.499V20.2491C16.125 20.3486 16.0855 20.4439 16.0152 20.5143C15.9448 20.5846 15.8494 20.6241 15.75 20.6241H3.75002C3.65056 20.6241 3.55517 20.5846 3.48485 20.5143C3.41452 20.4439 3.375 20.3486 3.375 20.2491V8.24914C3.375 8.24913 3.375 8.24912 3.375 8.24912C3.37501 8.14966 3.41452 8.05429 3.48485 7.98396C3.55517 7.91364 3.65055 7.87413 3.75 7.87412C3.75001 7.87412 3.75001 7.87412 3.75002 7.87412H7.50009H7.87509V7.49912V3.74904C7.87509 3.74904 7.87509 3.74903 7.87509 3.74902C7.8751 3.64957 7.91462 3.55419 7.98494 3.48387C8.05526 3.41355 8.15064 3.37403 8.25009 3.37402C8.2501 3.37402 8.25011 3.37402 8.25011 3.37402H20.2501C20.3495 3.37403 20.4449 3.41354 20.5152 3.48387C20.5856 3.5542 20.6251 3.64958 20.6251 3.74902V15.749C20.6251 15.8485 20.5856 15.9438 20.5152 16.0142C20.4449 16.0845 20.3495 16.124 20.2501 16.124H16.5ZM19.5001 15.374H19.8751V14.999V4.49902V4.12402H19.5001H9.00009H8.62509V4.49902V7.49912V7.87412H9.00009H15.75C15.75 7.87412 15.75 7.87412 15.75 7.87412C15.8495 7.87413 15.9448 7.91364 16.0152 7.98396C16.0855 8.05429 16.125 8.14966 16.125 8.24912C16.125 8.24912 16.125 8.24913 16.125 8.24914V14.999V15.374H16.5H19.5001Z",
    fill: "#2C3038",
    stroke: "#2C3038",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.05f32a3a.svg";
export { ForwardRef as ReactComponent };